import type { TOC } from '@ember/component/template-only';

import type {
  RateGroupRow,
  RateGroupSectionRow,
} from '../rate-groups-accordion';

interface TdRateGroupNameSignature {
  Args: {
    row: RateGroupRow | RateGroupSectionRow;
  };
}

/* Gives the name an id so the row's controls can include it in their accessible
   name, telling screen reader users which rate group each control belongs to.
   Section rows have no controls, so no id. */
const TdRateGroupName = <template>
  {{#if @row.isSection}}
    <span data-test-id="rate-group-section-name">{{@row.name}}</span>
  {{else}}
    <span
      data-test-id="rate-group-name"
      id="rate-group-{{@row.rateGroupId}}-name"
    >{{@row.name}}</span>
  {{/if}}
</template> satisfies TOC<TdRateGroupNameSignature>;

export default TdRateGroupName;
